import styled from 'styled-components';
import { BsCreditCard } from 'react-icons/bs';

const Container = styled.button`
  height: 40px;
  display: flex;
  align-items: center;
  gap: 2px;
`;

const IconView = styled.div`
  font-size: 20px;
  color: ${(props) => props.theme.editor.creditButtonIconColor};
  background-color: ${(props) => props.theme.editor.creditButtonBgColor};
  height: 100%;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
`;

const TextView = styled.div`
  height: 100%;
  min-width: 60px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: ${(props) => props.theme.editor.creditButtonBgColor};
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  font-weight: 600;
  font-size: 14px;
`;

const CreditButton = () => {
  return (
    <Container>
      <IconView>
        <BsCreditCard />
      </IconView>
      <TextView>{`0 C`}</TextView>
    </Container>
  );
};

export default CreditButton;
